<template>
    <div class="container">
        <p>
            Kuhu nüüd töttad? Nendele lehtedele sul kahjuks ligipääs puudub..
        </p>
        <Button label="Tagasi eelmisele lehele" style="margin-right: 20px" icon="pi pi-arrow-left" severity="contrast" @click="$router.back()" />
        <Button label="Ava e-pood" outlined icon="pi pi-shopping-cart" severity="contrast" @click="openShopLink" />
    </div>
</template>
  
<script>
import Button from 'primevue/button';

export default {
    name: 'errorPage',
    components: {
        Button
    },
    props: {
        shopData: {}
    },
    data() {
        return {
        };
    },
    computed: {
      
    },
    methods: {
        openShopLink() {
            window.location.href = this.shopData.homePageUrl+'/kataloog';
        }
    },
  };
</script>
  
<style scoped>
.container {
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 120px;
}
.container p {
    margin-top: auto;
    font-size: 30px;
    color: silver;
    font-family: 'Quicksand', sans-serif;
}
</style>